<script setup lang="ts">
import Button from '@satch-ui/components/button/Button.vue'
import CircleBadge from '@storefront-satch/components/atoms/circle-badge/CircleBadge.vue'

import { ChevronIcon } from '@fond-of/satch-icons'

const props = withDefaults(
  defineProps<{
    colorBadge?: string | undefined
    text?: string | undefined
  }>(),
  {
    colorBadge: '#000',
    text: 'Default Text',
  }
)
</script>

<template>
  <Button
    class="font-sans-semi-bold text-primary border-primary sm:mb-6.25 group mb-5 inline-flex w-full cursor-pointer items-center justify-start border-2 bg-transparent px-[0.7em] py-[0.55em]"
    variant="outlineBlue"
  >
    <div class="mr-0.5 size-6">
      <CircleBadge
        class="border-none"
        :style="{ background: props.colorBadge ? props.colorBadge : '' }"
      />
    </div>
    <div
      class="text-sm transition-transform duration-300 group-hover:translate-x-[5px]"
    >
      {{ props.text }}
    </div>
    <ChevronIcon
      class="text-primary z-10 ml-auto mr-2 size-4 transition-transform group-hover:translate-y-[10%]"
    />
  </Button>
</template>
